<template>
  <div class="d-flex flex-column align-center pt-15 px-2">
    <div class="text-h5 primary--text text--darken-1 font-weight-bold text-center text-wrap">{{ $t('label.experienceAtBranch', { branchName }) }}</div>
    <img src="@/assets/salon-review.png" width="500px" />
    <v-container class="px-10 my-10">
      <v-row>
        <v-col md="4" offset-md="3" class="pb-0 font-weight-medium">
          <div>1. {{ $t('label.cleanliness') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.CLEANLINESS]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
        <v-col md="4" class="pb-0 font-weight-medium">
          <div>2. {{ $t('label.ambience') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.AMBIENCE]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" offset-md="3" class="pb-0 font-weight-medium">
          <div>3. {{ $t('label.customerService') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.CUSTOMER_SERVICE]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
        <v-col md="4" class="pb-0 font-weight-medium">
          <div>4. {{ $t('label.recommendable') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.RECOMMENDABLE]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
      </v-row>
      <v-textarea v-model="comment" :placeholder="$t('placeholder.typeHere')" counter="250"></v-textarea>
    </v-container>

    <v-card-actions class="mb-8">
      <v-btn outlined color="primary darken-1" class="mr-15 px-12 rounded-pill text-capitalize align-self-center" @click="next">
        {{ $t('button.skip') }}
      </v-btn>
      <v-btn color="primary" class="px-12 rounded-pill green-gradient-right text-capitalize align-self-center" @click="submit">
        {{ $t('button.next') }}
      </v-btn>
    </v-card-actions>
    <app-dialog v-model="dialogIsOpen" title="" maxWidth="400">
      <div class="text-body-1 font-weight-medium my-5">{{ $t('message.rateToProceed') }}</div>
      <app-button class="green-gradient-right override-disabled-styles px-15 mt-5" type="submit" invert gradient :label="$t('button.okay')" @click="dialogIsOpen = false" />
    </app-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { ToReview } from '@/constants/enums'
import AppButton from '../AppButton.vue'
export default {
  components: { AppButton },
  props: {
    review: { type: Object, required: true },
    branchName: { type: String, required: true }
  },
  data() {
    return {
      ToReview,
      reviewForm: {
        posTransId: this.review.pos_transaction_id,
        reviews: [],
        comments: []
      },
      ratings: {},
      comment: null,
      dialogIsOpen: false
    }
  },
  methods: {
    ...mapMutations('review', ['setSalonStylistReviewForm']),
    next() {
      this.setSalonStylistReviewForm(this.reviewForm)
      this.$emit('stepUp')
    },
    submit() {
      if (Object.keys(this.ratings).length < 4) {
        this.dialogIsOpen = true
        return
      }
      for (let reviewType of Object.keys(this.ratings)) {
        this.reviewForm.reviews.push({
          type: ToReview.type.SALON,
          item_id: this.review.branch_id,
          review_type: reviewType,
          rating: this.ratings[reviewType]
        })
      }
      if (this.comment) {
        this.reviewForm.comments.push({
          type: ToReview.type.SALON,
          item_id: this.review.branch_id,
          rating: 0,
          comment: this.comment
        })
      }
      this.next()
    }
  }
}
</script>
